import { isNil, chunk } from 'lodash';
import { injectBasePath } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@legacy/HTMLRenderEngine/util/html-render-engine-util';

export const getCover = (book) => book?.pages.find(({ pageNumber }) => isNil(pageNumber));

export const formatCovers = (bookCoversHtmlText, books) => {
  return bookCoversHtmlText
    .map((promise, idx) => ({
      html:
        promise.status === 'fulfilled'
          ? injectBasePath(
              promise.value.data,
              getCover(books[idx]).src.slice(0, getCover(books[idx]).src.lastIndexOf('/'))
            )
          : undefined,
      id: books[idx].id,
      routeParam: books[idx].bookCode,
      title: books[idx].title,
    }))
    .filter((promise) => promise.html);
};

export const groupCoverRowsBasedOnScreenSize = (covers, groupSize) => {
  const chunkedCovers = chunk(covers, groupSize);
  return chunkedCovers;
};

export const findPageAndPopulatePageData = (pages, activePage) => {
  return pages?.find((p) => {
    const pageNumber = p?.pageNumber ?? p?.page?.pageNumber ?? 'cover';
    return pageNumber === activePage;
  });
};

export const findPagesAndPopulateReadStoryData = (pages, activePages) => {
  return activePages.reduce((acc, curr) => {
    if (curr !== 0 && !curr) return acc;

    const foundPage = pages?.find((p) => {
      const pageNumber = p.page.pageNumber ?? 'cover';
      return pageNumber === curr;
    });
    if (!foundPage) return acc;

    const { page, words } = foundPage;

    acc.push({
      id: page.id,
      pageNumber: page.pageNumber ?? 'cover',
      words,
    });

    return acc;
  }, []);
};
